import { AnyApiFactory, createApiFactory } from '@backstage/core-plugin-api';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import {
  graphQlBrowseApiRef,
  GraphQLEndpoints,
} from '@backstage-community/plugin-graphiql';

interface GraphQLRequestParams {
  query: string;
  variables?: Record<string, any>;
  operationName?: string;
}

export const graphqlApi: AnyApiFactory[] = [
  createApiFactory({
    api: graphQlBrowseApiRef,
    deps: {
      githubAuthApi: githubAuthApiRef,
    },
    factory: ({ githubAuthApi }) =>
      GraphQLEndpoints.from([
        {
          id: 'github',
          title: 'GitHub GraphQL API',
          fetcher: async (params: GraphQLRequestParams) => {
            try {
              const token = await githubAuthApi.getAccessToken(['repo']);

              const response = await fetch('https://api.github.com/graphql', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(params),
              });

              if (!response.ok) {
                throw new Error(
                  `GitHub API request failed with status ${response.status}: ${response.statusText}`,
                );
              }

              return await response.json();
            } catch (error) {
              if (error instanceof Error) {
                throw new Error(
                  `Failed to execute GraphQL query: ${error.message}`,
                );
              }
              throw new Error('Failed to execute GraphQL query: Unknown error');
            }
          },
        },
      ]),
  }),
];
